import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { UserCheck, CheckCircle2, Clock, Stethoscope } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const PendingActivations = ({ token }) => {
  const auth = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try {
      const r = await fetch(`${API}/api/backoffice/pending-activations`, { headers: auth });
      if (r.ok) setRows((await r.json()).pending || []);
    } catch { /* noop */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const activate = async (u) => {
    const r = await fetch(`${API}/api/backoffice/pending-activations/${u.id}/activate`, { method: "POST", headers: auth });
    const d = await r.json();
    if (!r.ok) return toast.error("Não foi possível ativar", { description: d.detail });
    toast.success("Plano ativado", { description: u.name || u.email });
    load();
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-testid="pending-activations">
      <div className="flex items-center gap-2 border-b border-slate-100 px-5 py-4">
        <UserCheck className="h-4 w-4 text-violet-600" />
        <h2 className="font-heading text-base font-bold text-slate-900">Aguardando ativação ({rows.length})</h2>
        <span className="ml-auto text-xs text-slate-400">Consulte o CRM e ative após confirmar o pagamento</span>
      </div>
      <div className="divide-y divide-slate-100">
        {rows.length === 0 && <p className="py-10 text-center text-sm text-slate-400">Nenhuma conta aguardando ativação.</p>}
        {rows.map((u) => (
          <div key={u.id} data-testid={`pending-row-${u.id}`} className="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-violet-50 text-violet-600"><Stethoscope className="h-4 w-4" /></div>
              <div>
                <p className="text-sm font-semibold text-slate-900">{u.name || u.email}</p>
                <p className="text-xs text-slate-500">{u.email} · CRM <span className="font-mono font-bold">{u.crm || "—"}</span>/{u.uf || "—"} · {u.specialty || "—"} · plano {u.plan || "—"}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {u.paid
                ? <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-[11px] font-semibold text-emerald-700"><CheckCircle2 className="h-3.5 w-3.5" /> Pago</span>
                : <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2.5 py-0.5 text-[11px] font-semibold text-amber-700"><Clock className="h-3.5 w-3.5" /> Aguardando pagamento</span>}
              <button
                data-testid={`activate-btn-${u.id}`}
                onClick={() => activate(u)}
                disabled={!u.paid}
                className="rounded-lg bg-slate-900 px-3.5 py-1.5 text-xs font-bold text-white transition-colors hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-200 disabled:text-slate-400"
              >
                Ativar plano
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
